import { CSSResult } from 'lit-element';

/**
 * Creates Global css styles
 *
 * @param {string} stylesheetID
 * @param {CSSResult} styles
 */
export function createGlobalStyles(stylesheetID, styles) {
  // we should include styles only once
  if (document.head.querySelector(`#${stylesheetID}`)) {
    return;
  }

  const stylesElement = document.createElement('style');
  stylesElement.id = stylesheetID;
  stylesElement.textContent = styles.toString();

  document.head.appendChild(stylesElement);
}
